import { requestApi } from './helper';
import { invalidateDestinationList, invalidateDestination } from './destination';

export const SAVE_CONTACT_INFO = 'SAVE_CONTACT_INFO';

export const saveContactInfo = (contactInfo, dispatch) => {
  dispatch(invalidateDestinationList());
  dispatch(invalidateDestination(contactInfo.destinationId));

  return { type: SAVE_CONTACT_INFO, contactInfo };
};

export const requestSaveContactInfo = (
  destinationId,
  contactInfo,
  errorCallback,
  successCallback,
) => {
  const requestProperties = {
    method: 'PATCH',
    body: contactInfo,
  };

  return requestApi(`/destinations/${destinationId}`, requestProperties, saveContactInfo, errorCallback, successCallback);
};
